import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=65879b4e&scoped=true&"
import script from "./TheAlert.vue?vue&type=script&lang=js&"
export * from "./TheAlert.vue?vue&type=script&lang=js&"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=65879b4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65879b4e",
  null
  
)

export default component.exports